import { Viewport, onListItemHref } from 'Common/utils';

export default class NavigationController {
    static init({ originalActiveLink = -1, numLinks = 0 } = {}) {
        const ctrl = new this(originalActiveLink, numLinks);
        let lastMobile = ctrl.isMobile;

        // Bootstrap dropdown on #userMenu
        const userMenuBtn = document.getElementById('userMenu');

        if (userMenuBtn && window.bootstrap?.Dropdown) {
            new window.bootstrap.Dropdown(userMenuBtn);
        }

        // stop propagation on navbar clicks
        const navbar = document.querySelector('.navbar');

        navbar?.addEventListener('click', (e) => e.stopPropagation());

        // open/close nav buttons
        const btnOpen = document.getElementById('btn-nav-open');
        const btnClose = document.getElementById('btn-nav-close');

        btnOpen?.addEventListener('click', ctrl.openNav);
        btnClose?.addEventListener('click', ctrl.closeNav);

        // wire up each link
        for (let i = 0; i < ctrl.numLinks; i++) {
            const navItem = document.getElementById(`nav-item-${i}`);

            if (!navItem) continue;
            if (!ctrl.isTouch) {
                navItem.addEventListener('mouseover', ctrl.activator(i));
            }
            navItem.addEventListener('click', ctrl.activator(i));

            // mobile links
            document
                .querySelectorAll('.mobile-nav-link[href]')
                .forEach((el) => el.addEventListener('click', () => el.classList.add('active')));

            const mobileItem = document.getElementById(`mobile-nav-item-${i}`);

            mobileItem?.addEventListener('click', ctrl.activator(i));
        }

        // promo and nav-child clicks
        document
            .querySelectorAll('.MenuCtaPromoBlock .link-list ul > li, .nav-children > ul > li')
            .forEach((li) => li.addEventListener('click', onListItemHref));

        // handle viewport changes
        Viewport.onChange(() => {
            const isMobile = ctrl.isMobile;

            document.querySelectorAll('.nav-children').forEach((el) => {
                el.style.maxHeight = isMobile ? '0' : 'none';
            });
            if (isMobile !== lastMobile && ctrl.activeLink >= 0) {
                const listEl = document.getElementById(`nav-list-${ctrl.activeLink}`);
                const ul = listEl?.querySelector('ul');

                if (listEl && ul) {
                    listEl.style.maxHeight = `${Math.ceil(ul.scrollHeight)}px`;
                }
            }
            lastMobile = isMobile;
        });
    }

    activeLink = -1;
    originalActiveLink = -1;

    get isTouch() {
        return Viewport.viewport.is.touch;
    }
    get isMobile() {
        return Viewport.viewport.is.mobile;
    }

    setActive(index) {
        if (index === this.activeLink) return;

        // Clear previous
        if (this.activeLink >= 0) {
            document.querySelector(`#nav-item-${this.activeLink} > a`)?.classList.remove('selected');
            document.getElementById(`navbar-cta-${this.activeLink}`)?.classList.add('d-none');

            const prevList = document.getElementById(`nav-list-${this.activeLink}`);

            if (prevList) {
                prevList.classList.remove('selected');
                prevList.style.maxHeight = this.isMobile ? '0' : 'none';
            }
        }

        // Activate new
        if (index >= 0) {
            document.querySelector(`#nav-item-${index} > a`)?.classList.add('selected');
            document.getElementById(`navbar-cta-${index}`)?.classList.remove('d-none');

            const listEl = document.getElementById(`nav-list-${index}`);

            if (listEl) {
                listEl.classList.add('selected');
                const ul = listEl.querySelector('ul');

                listEl.style.maxHeight = ul && this.isMobile ? `${Math.ceil(ul.scrollHeight)}px` : 'none';
            }
        }

        this.activeLink = index;
    }

    constructor(originalActiveLink = -1, numLinks = 0) {
        this.originalActiveLink = originalActiveLink;
        this.numLinks = numLinks;
        this.setActive(originalActiveLink);
    }

    closeNav = () => {
        document.removeEventListener('click', this.closeNav);
        const navContainer = document.getElementById('nav-container');
        const btnOpen = document.getElementById('btn-nav-open');

        navContainer?.classList.replace('show', 'hide');
        btnOpen?.classList.remove('hide');
        navContainer?.classList.remove('enabled');
        setTimeout(() => {
            this.setActive(this.originalActiveLink);
            navContainer?.classList.remove('enabled');
        }, 500);
    };

    openNav = () => {
        const navContainer = document.getElementById('nav-container');
        const btnOpen = document.getElementById('btn-nav-open');

        navContainer?.classList.replace('hide', 'show');
        btnOpen?.classList.add('hide');
        document.addEventListener('click', this.closeNav);
        setTimeout(() => {
            navContainer?.classList.add('enabled');
        }, 400);
    };

    activator = (i) => () => this.setActive(i);
}
